/*
 * Copyright © 2021-present Tacnode Inc. All rights reserved.
 * The information contained in this software is confidential and proprietary to Tacnode Inc. and its subsidiaries. No part of this software may be used, copied, reproduced, modified, displayed, performed, executed, published, distributed, conveyed, stored, transmitted, or otherwise exploited in any form or by any means, including but not limited to electronic, mechanical, photocopying, recording, transcribing, without the prior written consent of Tacnode Inc.
 * Any violation of the above terms will constitute an infringement of copyright and will be subjected to legal action.
 */
import { Space } from 'antd'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { PlatformList } from '@/components/PlatformList'
import { TPlatformListService } from '@/components/PlatformList/interface'
import { useTimeFilter } from '@/hooks/useTimeFilter'
import { useVoucherRedeemedRecordsColumns } from '@/pages/billing/Vouchers/VoucherRedeemedRecords/useVoucherRedeemedRecordsColumns'
import { DeductionType } from '@/pages/billing/interface'
import { accountClient } from '@/services/cloudClient/accountClient'
import { createOrders } from '@/utils/createOrders'

export function VoucherRedeemedRecords() {
  const { t } = useTranslation()
  const { contractId } = useParams()
  const { filter: timeFilter, time } = useTimeFilter(null, {
    format: 'YYYY-MM',
    picker: 'month',
    placeholder: t('Select Billing Date'),
    style: { width: 180 },
    allowClear: true,
  })
  const columns = useVoucherRedeemedRecordsColumns()
  const emitter = PlatformList.useCreateEmitter()

  const service: TPlatformListService = ({ pagination, sorter }, options) => {
    const { current, pageSize } = pagination || {}
    return accountClient.deductionApi.listDeductions(
      contractId,
      {
        pageNum: current,
        pageSize,
        deductType: DeductionType.voucher,
        statementStart: time?.startOf('month').valueOf(),
        ...createOrders(sorter),
      },
      options,
    )
  }

  useEffect(() => {
    emitter.fire({
      pagination: {
        current: 1,
        pageSize: 10,
      },
    })
  }, [time])

  return (
    <PlatformList
      emitter={emitter}
      service={service}
      columns={columns}
      createTitle={() => (
        <>
          <Space>{timeFilter}</Space>
        </>
      )}
    />
  )
}
